<template>
  <v-container fluid class="pa-2">

    <div class="traka">
      <h2 class="naslov">{{ lang.Companies }}</h2>
      <div class="brojke">
        <div class="brojka">
          <div class="v">{{ sve.length }}</div>
          <div class="o">ukupno</div>
        </div>
        <div class="brojka">
          <div class="v">{{ brojAktivnih }}</div>
          <div class="o">aktivnih</div>
        </div>
        <div class="brojka" :class="{istice: brojNeaktivnih > 0}">
          <div class="v">{{ brojNeaktivnih }}</div>
          <div class="o">neaktivnih</div>
        </div>
      </div>
    </div>

    <v-card tile>
      <!-- Po zadanom se vide SAMO aktivne. Od 98 firmi njih 35 je neaktivno i
           u svakodnevnom radu samo smetaju - traže se izrijekom. -->
      <v-tabs v-model="jahac" height="42" show-arrows>
        <v-tab>
          Aktivne
          <v-chip x-small class="ml-2">{{ brojAktivnih }}</v-chip>
        </v-tab>
        <v-tab>
          Neaktivne
          <v-chip x-small class="ml-2">{{ brojNeaktivnih }}</v-chip>
        </v-tab>
        <v-tab>
          Sve, i neaktivne
          <v-chip x-small class="ml-2">{{ sve.length }}</v-chip>
        </v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <div class="alati">
        <v-text-field
          v-model="trazi"
          label="Traži po nazivu, OIB-u ili gradu"
          dense
          hide-details
          clearable
          append-icon="mdi-magnify"
          class="alat-trazi"
        ></v-text-field>

        <v-select
          v-model="grad"
          :items="gradovi"
          label="Grad"
          dense
          hide-details
          clearable
          class="alat-uzak"
        ></v-select>

        <v-checkbox
          v-model="bezERacuna"
          label="samo bez eRačuna"
          dense
          hide-details
          class="mt-0 pt-0 ml-2"
        ></v-checkbox>

        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="nova">
          <v-icon small left>mdi-plus</v-icon>Nova tvrtka
        </v-btn>
      </div>

      <v-divider></v-divider>

      <div v-if="saving" class="text-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>

      <div v-else-if="prikazane.length === 0" class="prazno">
        Nema tvrtki po ovim uvjetima.
      </div>

      <div v-else>
        <div
          v-for="f in prikazane"
          :key="f.id"
          class="firma"
        >
          <div class="pojas" :class="{ne: !f.Activ}"></div>

          <div class="sredina" @click="navigateTo(f)">
            <div class="naziv" :class="{sivo: !f.Activ}">
              {{ f.CompanyName }}
              <span v-if="imaERacun(f)" class="znak era">eRačun</span>
              <span v-if="f.notinVAT" class="znak pdv">nije u PDV-u</span>
            </div>
            <div class="meta">
              <span v-if="f.CompanyVATID">OIB {{ f.CompanyVATID }}</span>
              <span v-if="adresa(f)"><span class="tocka">&middot;</span>{{ adresa(f) }}</span>
              <span v-if="f.CompanyNameDatabase">
                <span class="tocka">&middot;</span>{{ f.CompanyNameDatabase }}
              </span>
            </div>
          </div>

          <div class="desna">
            <span class="stanje" :class="f.Activ ? 'da' : 'ne'">
              {{ f.Activ ? 'aktivna' : 'neaktivna' }}
            </span>
            <v-btn x-small text color="primary" @click.stop="uredi(f)">Uredi</v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import CompService from '@/services/CompService'
import langEn from './companyDescEn'
import langHr from './companyDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'

const AKTIVNE = 0
const NEAKTIVNE = 1

export default {
  name: 'complist',
  data () {
    return {
      sve: [],
      saving: false,
      jahac: AKTIVNE,
      trazi: '',
      grad: null,
      bezERacuna: false,
      lang: {},
      langC: {}
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.$store.dispatch('seteditItem', 0)
    try {
      this.saving = true
      this.sve = (await CompService.index()).data.companys
    } catch (err) {
      // eslint-disable-next-line
      console.log(err)
      this.sve = []
    } finally {
      this.saving = false
    }
  },
  computed: {
    brojAktivnih () {
      return this.sve.filter(f => f.Activ === true).length
    },
    brojNeaktivnih () {
      return this.sve.filter(f => f.Activ !== true).length
    },
    gradovi () {
      const po = {}
      this.sve.forEach(f => {
        const g = (f.CompanyCity ? String(f.CompanyCity).trim() : '')
        if (g) { po[g] = true }
      })
      return Object.keys(po).sort((a, b) => a.localeCompare(b, 'hr'))
    },
    prikazane () {
      const t = (this.trazi ? this.trazi : '').toLowerCase().trim()
      return this.sve.filter(f => {
        if (this.jahac === AKTIVNE && f.Activ !== true) { return false }
        if (this.jahac === NEAKTIVNE && f.Activ === true) { return false }
        if (this.grad && String(f.CompanyCity || '').trim() !== this.grad) { return false }
        if (this.bezERacuna && this.imaERacun(f)) { return false }
        if (t) {
          const u = ((f.CompanyName || '') + ' ' + (f.CompanyNameShort || '') + ' ' +
            (f.CompanyVATID || '') + ' ' + (f.CompanyCity || '') + ' ' +
            (f.CompanyNameDatabase || '')).toLowerCase()
          if (u.indexOf(t) === -1) { return false }
        }
        return true
      }).sort((a, b) => String(a.CompanyName || '').localeCompare(String(b.CompanyName || ''), 'hr'))
    }
  },
  methods: {
    // Posrednik je postavljen i ima ključ - inače eRačun ne radi, pa oznaka
    // ne bi bila točna.
    imaERacun (f) {
      return !!(f && Number(f.eRacunProvider) > 0 && f.eRacunProviderAPIkey)
    },
    adresa (f) {
      const d = [f.CompanyStreet, f.CompanyBuildingNameNumber].filter(x => x).join(' ')
      return [d, f.CompanyCity].filter(x => x).join(', ')
    },
    navigateTo (f) {
      this.$store.dispatch('setCompanyid', f.id)
      this.$router.push({name: 'companyview'}).catch(() => {})
    },
    uredi (f) {
      this.$store.dispatch('setCompanyid', f.id)
      this.$store.dispatch('seteditItem', 1)
      this.$router.push({name: 'companycreate'}).catch(() => {})
    },
    nova () {
      this.$store.dispatch('seteditItem', 0)
      this.$router.push({name: 'companycreate'}).catch(() => {})
    }
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.brojke { display: flex; gap: 20px; margin-left: auto; flex-wrap: wrap; }
.brojka { text-align: right; }
.brojka .v { font-size: 18px; font-weight: 700; line-height: 1.1; }
.brojka .o { font-size: 11px; opacity: .85; }
.brojka.istice .v { color: #ff8a80; }

.alati { display: flex; gap: 10px; align-items: center; padding: 8px 12px; flex-wrap: wrap; }
.alat-trazi { max-width: 300px; }
.alat-uzak { max-width: 170px; }

.firma {
  display: flex;
  gap: 10px;
  padding: 9px 12px;
  border-bottom: 1px solid #f0f3f6;
  align-items: center;
}
.firma:last-child { border-bottom: none; }
.firma:hover { background: #fafcff; }

.pojas { width: 4px; flex: 0 0 4px; align-self: stretch; border-radius: 2px; background: #2e7d32; }
.pojas.ne { background: #bdbdbd; }

.sredina { flex: 1 1 auto; min-width: 0; cursor: pointer; }
.naziv { font-weight: 500; }
.naziv.sivo { color: #5f6b7a; }
.meta { font-size: 12px; color: #5f6b7a; margin-top: 2px; }
.meta .tocka { opacity: .5; margin: 0 5px; }

.znak {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  margin-left: 6px;
  white-space: nowrap;
}
.znak.era { background: #e8f5e9; color: #2e7d32; }
.znak.pdv { background: #fff3e0; color: #ef6c00; }

.desna { flex: 0 0 auto; display: flex; align-items: center; gap: 6px; }
.stanje { font-size: 12px; min-width: 72px; text-align: right; }
.stanje.da { color: #2e7d32; }
.stanje.ne { color: #9e9e9e; }

.prazno { text-align: center; padding: 34px 12px; color: #5f6b7a; }

@media (max-width: 900px) {
  .brojke { width: 100%; margin-left: 0; justify-content: space-between; }
}
@media (max-width: 600px) {
  .firma { flex-wrap: wrap; }
  .desna { width: 100%; justify-content: flex-start; padding-left: 14px; }
  .alat-trazi, .alat-uzak { max-width: none; flex: 1 1 100%; }
}
</style>
